import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=c01dd9aa&scoped=true"
import script from "./Template.vue?vue&type=script&setup=true&lang=js"
export * from "./Template.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Template.vue?vue&type=style&index=0&id=c01dd9aa&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01dd9aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c01dd9aa')) {
      api.createRecord('c01dd9aa', component.options)
    } else {
      api.reload('c01dd9aa', component.options)
    }
    module.hot.accept("./Template.vue?vue&type=template&id=c01dd9aa&scoped=true", function () {
      api.rerender('c01dd9aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/preventive-maintenance/list/items/Template.vue"
export default component.exports